import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TenantConfigService } from '../../../../core/config/tenant-config';
import { SeoService } from '../../../../core/services/seo.service';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './contact.html',
  styleUrl: './contact.scss'
})
export class Contact implements OnInit {
  public tenantConfigService = inject(TenantConfigService);
  private seoService = inject(SeoService);

  ngOnInit(): void {
    const siteName = this.tenantConfigService.settings?.Name || 'Apostille & Legalization Services';
    this.seoService.setPageSeo({
      id: 0,
      meta_title: `Contact Us | ${siteName}`,
      meta_description: `Get in touch with ${siteName}. Reach us by phone, email, or visit our office for expert document apostille and authentication assistance.`,
      meta_keywords: 'contact apostille, apostille help, customer support, document authentication contact',
      canonical_url: '/contact',
      is_active: true
    });
  }
}
